import type { ReactNode } from 'react';
import { styled } from 'goober';

import { Flexbox } from '../flexbox/flexbox';

import type { TagVariant } from './variants';

type IWeight = 'normal' | 'semibold';

interface StatusTagProps {
  variant: TagVariant;
  children?: ReactNode;
  weight?: IWeight;
  onClick?: () => void;
  bordered?: boolean;
  isVisible?: boolean;
}

const weights = {
  normal: 400,
  semibold: 500,
};

export const StatusTag = ({
  variant,
  children,
  onClick,
  weight = 'normal',
  bordered,
  isVisible = true,
}: StatusTagProps) => (
  <TagWrapper
    name="status-tag"
    alignItems="center"
    justify="space-between"
    gap="8px"
    variant={variant}
    weight={weight}
    onClick={onClick}
    bordered={bordered}
    style={{ visibility: isVisible ? 'visible' : 'hidden' }}
  >
    {children}
  </TagWrapper>
);

const TagWrapper = styled(Flexbox)<{
  variant: TagVariant;
  weight: IWeight;
  bordered?: boolean;
}>`
  max-width: fit-content;
  border-radius: 4px;
  padding: 4px 12px;
  white-space: nowrap;

  background-color: ${({ theme, variant }) =>
    theme.palettes.component.tag[variant].main};
  color: ${({ theme, variant }) => theme.palettes.component.tag[variant].text};

  ${({ theme }) => theme.typography.atoms.tags.status}
  font-weight: ${({ weight }) => weights[weight]};

  border: ${({ theme, bordered }) =>
    bordered ? `1px solid ${theme.colors.gray.c5}` : 'none'};
`;
